import {useState, useEffect} from 'react';
import breakpoints from '../../config/tailwind/tailwind-breakpoints';

function parse(bp: string) {
  // bp comes as "767px" → returns number 767
  return parseInt(bp.replace('px', ''), 10);
}

function getDimensions() {
  if (typeof window === 'undefined') {
    return {width: 0, height: 0};
  }
  return {width: window.innerWidth, height: window.innerHeight};
}

function getDevice(width: number) {
  const bp = breakpoints.window;

  if (width >= parse(bp.lg)) return 'desktop';
  if (width >= parse(bp.md)) return 'tablet';
  return 'mobile';
}

export default function useDevice() {
  const init = () => {
    const {width, height} = getDimensions();
    return {width, height, device: getDevice(width)};
  };

  const [state, setState] = useState(init);

  useEffect(() => {
    const onResize = () => {
      const {width, height} = getDimensions();
      setState({width, height, device: getDevice(width)});
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return state;
}
